<template>
  <div class="select-flow">
    <svg ghIcon="logo-gatehub" class="ico-dark ico" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" viewBox="0 0 1920 600" width="100%" height="100%" fill="currentColor" fill-rule="evenodd"><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M823,216c17.3-0.2,34.3,5.1,48.4,15.1c1.3,1.6,2.1,3.6,2.2,5.7v0.5c0,4.5-3,7.4-8.9,8.5  c-0.9,0-6.7-2.5-17.2-7.5c-6.4-2.6-13.1-3.9-20-4h-7.2c-16.5,0-32.4,8-47.5,23.9c-9.8,13.4-14.7,27.1-14.7,41.2v1.8  c0,23,10.6,41.7,31.9,56.3c11.1,6.3,22.2,9.4,33.3,9.4h1.8c11,0,21.9-3,32.8-8.9v-40.4h-32.1c-5.5-1-8.3-3.8-8.3-8.5v-0.3  c1-5.7,3.7-8.5,8.3-8.5h41.4c4.4,0,7.1,2.8,8,8.5V358c0,7.2-1.8,11.7-5.3,13.4c-15.1,8.9-29.8,13.3-44,13.3h-2.6  c-27.8,0-51-12.9-69.8-38.7c-8.9-14.5-13.3-29.8-13.3-45.7c0-28.3,12.6-51.7,37.8-70.1C793.6,220.7,808.5,216,823,216z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M994.2,217c5.4,0,9.4,5.4,12,16.3c35.5,92.5,53.5,139.9,53.8,142.1v1.3c0,4.4-2.8,7-8.3,8h-0.5  c-5.2,0-8.9-5-11.1-15l-19.9-51.7h-51.7l-24.2,64c-2.4,1.8-4.5,2.7-6.3,2.7h-0.9c-5.6-1-8.3-3.8-8.3-8.3v-0.5l15-40.6  c26.2-68.3,40.5-106.3,42.8-113.8C989.3,218.4,991.8,217,994.2,217L994.2,217z M994.2,250.4l-18.6,50.3h37.9v-0.5l-18.9-49.8H994.2z  "></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M1101.6,216h109.7c5.3,1,8,3.7,8,8v1.8c0,4.3-3.2,6.8-9.7,7.5h-44.2v143.4c0,4.4-2.8,7-8.5,8h-0.3  c-4.6,0-7.4-3-8.5-9V233.4h-45c-5.9-1.2-8.9-4.1-8.9-8.8C1095.3,218.9,1097.8,216,1101.6,216L1101.6,216z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M1291.1,215.3l2.2,0.5h87.4l1.8-0.5c5.1,0,8,3.2,8.9,9.8c-1.2,5.4-4.4,8.1-9.7,8.1H1300v60.2h53.4l6.3-0.5  c4,0,6.7,3,8,8.9c0,3.9-2.4,6.9-7.1,8.9l-8.9-0.5H1300v57.3h83.8c4.1,0,6.7,3.1,7.6,9.4c-1.6,5.3-4.2,7.9-8,7.9h-92.3  c-5.6-1-8.4-3.9-8.4-8.5v-152c0.8-5.7,3.7-8.5,8.4-8.5L1291.1,215.3L1291.1,215.3z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M1458.3,216.3h1.8c5.3,1.1,8,3.4,8,7v70.2h83.7v-68.9c1-5.6,3.6-8.3,8-8.3h1.3c5.3,1,8,3.7,8,8v152.9  c0,3.9-2.8,6.4-8.5,7.5h-0.4c-5.6-1-8.4-3.9-8.4-8.5v-65.9H1468v66.3c0,4.4-2.8,7.1-8.4,8h-0.4c-4.6,0-7.4-3-8.5-9V226  C1451.4,219.5,1453.9,216.3,1458.3,216.3L1458.3,216.3z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M1638.9,216.3h1.8c5.3,1.1,8,3.4,8,7V318c0,20.4,5.8,34,17.4,40.9c6.9,5.5,15.5,8.5,24.4,8.5  c17.3,0,30.3-8.9,39-26.7c1.8-5.6,2.7-11.5,2.7-17.4v-98.7c1-5.6,3.6-8.3,8-8.3h1.3c5.3,1,8,3.7,8,8v103.5  c0,17.7-8.5,33.1-25.4,46.2c-10.6,7.1-21.4,10.7-32.4,10.7h-3c-18.4,0-34.4-9-48-27.1c-6.2-9.7-9.3-21.7-9.3-36V226  C1632.1,219.5,1634.6,216.3,1638.9,216.3L1638.9,216.3z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M1820.5,216.5l2.1,0.2h27l1.8-0.2c13.5,0,25,6.3,34.5,19c4.7,6.8,7.2,14.8,7.2,23v1.3c0,10.1-4,19.7-12,28.8  c19.2,10.6,28.8,25.9,28.8,46c0,20.2-10.5,35.7-31.5,46.5c-5.8,2.2-11.9,3.4-18.1,3.5h-39.9c-5.7-1-8.5-3.9-8.5-8.5v-151  c0.9-5.7,3.7-8.5,8.5-8.5L1820.5,216.5L1820.5,216.5z M1829.4,234.1v49.6h16.3c14.5,0,23.8-5.2,27.9-15.5c1.1-2.8,1.7-5.9,1.8-8.9  V258c0-11.4-6.6-19.2-19.9-23.4l-9.3-0.5L1829.4,234.1z M1829.4,301v66.4h23c16.9,0,28.2-4.9,34-14.6c3.8-5.3,5.8-11.7,5.7-18.2  v-0.8c0-15.9-8.7-26.6-26.1-32l-12.4-0.7L1829.4,301z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M72.8,362.8C38.1,362.8,10,334.7,10,300s28.2-62.8,62.8-62.8c5.6,0,11.2,0.8,16.7,2.3l0,0  c33.4,9.2,53.1,43.8,43.9,77.2C125.9,344,101.1,362.8,72.8,362.8z M72.8,254.6c-25.1,0-45.4,20.3-45.4,45.4s20.3,45.4,45.4,45.4  c25.1,0,45.4-20.3,45.4-45.4c0-20.4-13.6-38.3-33.3-43.7C81,255.1,76.9,254.6,72.8,254.6L72.8,254.6z"></path><polygon xmlns="http://www.w3.org/2000/svg" class="st1" points="383.6,412.3 322.1,305.8 199.1,305.8 199.1,294.2 322.1,294.2 383.6,187.7 393.6,193.5 332.2,300  393.6,406.5 "></polygon><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M451.9,581.7c-34.7,0.1-62.9-28-62.9-62.7c-0.1-34.7,28-62.9,62.7-62.9c5.7,0,11.3,0.8,16.8,2.3l0,0  c33.4,9.3,53,43.9,43.8,77.3C504.8,562.7,480.1,581.6,451.9,581.7z M451.8,473.4c-25.1,0-45.4,20.4-45.4,45.5  c0,25.1,20.4,45.4,45.5,45.4c25.1,0,45.4-20.4,45.4-45.5c0-20.5-13.7-38.4-33.4-43.8C460,473.9,455.9,473.4,451.8,473.4L451.8,473.4  z"></path><path xmlns="http://www.w3.org/2000/svg" class="st0" d="M451.8,144c-34.7,0-62.8-28.2-62.7-62.9s28.2-62.8,62.9-62.7c5.6,0,11.2,0.8,16.6,2.2l0,0  c33.4,9.2,53.1,43.8,43.9,77.2C504.9,125.1,480.1,144,451.8,144z M451.8,35.7c-25.1,0-45.5,20.3-45.5,45.4  c0,20.5,13.7,38.4,33.4,43.9c24.2,6.7,49.2-7.5,55.9-31.7c6.6-24.2-7.6-49.2-31.7-55.9l0,0C460,36.3,455.9,35.7,451.8,35.7  L451.8,35.7z"></path></svg>
      <h4 style="text-align: center; margin: 0; margin-top: 10px;">
          Buy and sell XRP with GateHub
      </h4>

      <p style="color: red">{{ debug }}</p>

      <p style="text-align: center; margin: auto; font-size: 0.8rem;">{{ walletAddress }}</p>

      <LoaderSpinner v-if="loading" style="margin: auto;"/>

      <template v-else>
          <div class="tc-info" v-if="tcAccept !== true">
              <p>By agreeing to the terms of this User Agreement, you declare that you have read, understood and agree to the content and agree to our Privacy Statement and disclaimer.</p>

              <p>GateHub is a third-party on- & off-ramp service provider. You will be redirected to GateHub's widget and website. XRPL Labs is not resposible for the content or services provided by GateHub or any damages or loss it may cause to you due to the use of GateHub's services. Please contact GateHub directly for any issues and do read the terms of service of GateHub.</p>
          </div>

          <div class="select-flow-buttons">
              <template v-if="tcAccept === true">
                <button v-if="!token" @click="authenticate()" class="btn blue">Authenticate</button>
                <template v-else>
                  <button @click="$router.push({ name: 'deposit', query: { walletAddress, fiatType, token, xummToken } })" class="btn green">Deposit</button>
                  <button @click="$router.push({ name: 'withdrawal', query: { walletAddress, fiatType, token, xummToken } })" class="btn red">Withdrawal</button>
                </template>
              </template>
              <button class="btn blue" @click="acceptTermsAndConditions()" v-else>Accept</button>
          </div>
      </template>
  </div>
</template>

<script>
import pkceChallenge from 'pkce-challenge'

import LoaderSpinner from '@/components/LoaderSpinner.vue'

export default {
    name: 'App',
    components: { LoaderSpinner },
    data() {
        return {
            flow: null,
            debug: null
        }
    },
    computed: {
        loading() {
            return this.$store.getters.isLoading
        },
        tcAccept() {
            return this.$store.getters.tcAccepted
        },
        token() {
            return this.$store.getters.getAccessToken
        },
        xummToken() {
            return this.$store.getters.xAppJWT
        },
        userData: {
            get() {
                return this.$store.getters.getUserData
            },
            set(value) {
                this.$store.dispatch('setUserData', value)
            }
        },
        walletAddress() {
            return this.$store.getters.walletAddress
        },
        fiatType() {
            return this.$store.getters.fiatDefault
        }
    },
    methods: {
        alert(msg) {
            alert(msg)
        },
        async authenticate() {
            this.$store.dispatch('isLoadingState', true)
            const challenge = pkceChallenge()
            const nonce = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) //random string
    
            // delete test data:
            // const challenge = {
            //   code_verifier: 'u1ta-MQ0e7TcpHjgz33M2DcBnOQu~aMGxuiZt0QMD1C',
            //   code_challenge: 'CUZX5qE8Wvye6kS_SasIsa8MMxacJftmWdsIA_iKp3I'
            // }

            // const nonce = 'STATE123456'
    
            localStorage.setItem('state', nonce)
            localStorage.setItem('challenge', JSON.stringify(challenge))
    
            const qstring = new URLSearchParams({
                client_id: process.env.VUE_APP_GATEHUB_KEY,
                // redirect_uri: 'localhost:8080',
                scope: 'ramp',
                response_type: 'code',
                response_mode: 'query',
                state: nonce,
                // nonce: nonce,
                code_challenge_method: 'S256',
                code_challenge: challenge.code_challenge
            })
            window.open(`https://${this.$store.getters.isSandbox ? 'sandbox.' : ''}gatehub.net/oauth2/auth?${qstring}`)
        },
        async acceptTermsAndConditions() {
            this.$store.dispatch('isLoadingState', true)
            await this.$store.dispatch('setUserDataStore', { key: 'onboarding', payloadJSON: { init: true } })
            this.$store.dispatch('isLoadingState', false)
        }
    }
}
</script>

<style scoped>
.select-flow {
  display: flex;
  flex-direction: column;
  padding: 20px;
  align-content: center;
  height: calc(100vh - 40px);
  max-width: 460px;
  margin: auto;
}
svg {
  height: 50px;
}
.st1{fill:#8BBDE6;}
.select-flow-buttons {
  display: flex;
  justify-content: space-evenly;
  margin-top: auto;
  flex-direction: column;
}
.tc-info {
  border: 1px solid rgb(0 134 251);
  border-radius: 5px;
  background-color: rgb(0 134 251 / 50%);
  margin: auto;
  padding: 0 15px;
}
.select-flow .btn {
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  color: #666;
  display: inline-block;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  padding: 0.375rem 0.75rem;
  text-align: center;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  user-select: none;
  vertical-align: middle;
  white-space: normal;
  cursor: pointer;
  width: auto;
  margin-bottom: 15px;
}
.select-flow .btn.red {
  background-color: #bd2a1f;
  border-color: #bd2c1f ;
  color: #fff;
}
.select-flow .btn.green {
  background-color: #6bbd1f;
  border-color: #6bbd1f;
  color: #fff;
}
.select-flow .btn.blue {
  background-color: rgb(0, 134, 251);
  border-color: rgb(0, 134, 251);
  color: #fff;
}
.select-flow .btn:disabled,
.select-flow .btn[disabled] {
cursor: not-allowed;
background-color: #6a6a6a52 !important;
color: grey !important;
border-color: transparent;
}
</style>